import { render } from "./ChoiceList.vue?vue&type=template&id=5fc89506&scoped=true"
import script from "./ChoiceList.vue?vue&type=script&lang=js"
export * from "./ChoiceList.vue?vue&type=script&lang=js"

import "./ChoiceList.vue?vue&type=style&index=0&id=5fc89506&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc89506"]])

export default __exports__